import { SortableFilter }          from './../common/sortable-filter';

export class UserSortableFilter extends SortableFilter {
    public activeOnly = true;
    public page = 0;
    public pageSize = 0;
    public Roles;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/user-list/user-sortable-filter.ts